<template>
  <div>
    <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link">
        {{ mesgObj.name }}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="item in mesgObj.children"
          :key="item.uuid"
          :command="item.path"
          >{{ item.name }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
export default {
  props: {
    mesgObj: Object,
    default: () => ({}),
  },
  data() {
    return {};
  },
  watch: {},
  created() {},
  methods: {
    handleCommand(url) {
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$message({
          showClose: true,
          message: "敬请期待！",
          type: "warning",
        });
      }
    },
  },
};
</script>
<style scoped lang="less">
.el-dropdown {
  font-size: 16px;
}
.el-dropdown-menu__item{
  color: #000000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/header/mapMesgList.vue